import script from "./StatHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./StatHeader.vue?vue&type=script&setup=true&lang=js"

import "./StatHeader.vue?vue&type=style&index=0&id=718a1ba8&scoped=true&lang=scss"

import exportComponent from "E:\\Projects\\big-screen\\ori\\nnu-data-viewer-1204\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-718a1ba8"]])

export default __exports__